import { HttpClient } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { AppService, GRSSResponse, ValueIdPair } from 'src/app/_services/app.service';
import { ManageCommunicationsComponent } from '../manage-communications.component';

@Component({
    selector: 'app-add-schedule',
    templateUrl: './add-schedule.component.html',
    styleUrls: ['./add-schedule.component.scss'],
    standalone: false
})
export class AddScheduleComponent implements OnInit {

  schedule: ScheduleInitial;
  senderlist: ValueIdPair[];
  // tslint:disable-next-line: max-line-length
  constructor(private service: AppService, private translate: TranslateService, @Inject('BASE_URL') private baseUrl: string, @Inject(MAT_DIALOG_DATA) public data, private http: HttpClient, public dialogRef: MatDialogRef<ManageCommunicationsComponent>) { }

  ngOnInit() {
    this.InitializeForm();
    this.GetSenderlist();
  }

  /** Gets the senderlist for schedules */
  GetSenderlist() {
    this.http.get<ValueIdPair[]>(this.baseUrl + 'api/communications/getSenderlist').subscribe(result => {
      this.senderlist = result;
    }, error => {
      console.error(error);
    });
  }

  /** Initializes the form */
  InitializeForm() {
    this.schedule = {
      senderId: '',
      name: '',
      subject: ''
    }
  }

  /** Save button event */
  OnSave() {
    if (this.schedule.name && this.schedule.senderId && this.schedule.subject) {
      this.service.showSpinner();
      this.http.post<GRSSResponse>(this.baseUrl + 'api/communications/addSchedule', this.schedule).subscribe(result => {
        let navigated = false;
        if (result.statusCode === 1) {
          this.dialogRef.close(1);
        } else if (result.statusCode === 4) {
          navigated = true;
          this.dialogRef.close(1);
          this.service.SaveStatus(true, 'Communications.Scheduler.addSchedule.header', result.statusMessage);
        }

        if (!navigated) {
          this.service.SaveStatus(false, 'Communications.Scheduler.addSchedule.header', result.statusMessage);
        }
      }).add(() => {
        this.service.hideSpinner();
      });
    }
  }

  /** Cancel button event */
  OnCancel() {
    this.dialogRef.close(0);
  }

}

/** An interface to access schedule initial details */
interface ScheduleInitial {
  name: string;
  senderId: string;
  subject: string;
}
